<template>
  <div class="product-block-inner step-four">

    <span class="product-block-span step-four-top-margin">
      <h1 v-html="title"></h1>
      <h3 v-html="subtitle"></h3>

      <!-- FLOATING LOGOS -->
      <div class="hero-social-logos">
        <span :class="`social-logo ${logo}-social-logo ${logoClass(index)}`" v-for="(logo, index) in socialLogos">
          <img :src="getSocialImageUrl(logo)">
        </span>

        <DemoButton :buttonMessage="'Software, Owning Audience'"></DemoButton>
      </div>

    </span>

    <span class="product-block-span step-four-images">
      <img class="optimize-image" src="../../../../assets/winter-2019/hero-audiences.png">
    </span>

  </div>
</template>

<script>

import logos from '../logos'

import DemoButton from './GetDemoButton'

export default {
  data() {
    return {
      title: 'Own your shopper audiences across retailers',
      subtitle: 'Capture and convert qualified shoppers who signal they shop at eRetail or DTC. MikMak audiences become one of your top performers. MikMak can send these audiences directly to your preferred ad manager or CDP.',
      socialLogos: logos.audience
    }
  },
  components: {
    DemoButton
  },
  mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.step-four', { delay: 250, duration: 500 })
  },
  methods: {
    logoClass(index) {
      return index % 2 == 0 ? 'even-class' : 'odd-class'
    },
    getSocialImageUrl(name) {
      var images = require.context('../../../../assets/social-logos/')
      return images(`./${name}.png`)
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .product-block-inner {
    display: flex;
    margin: 24px auto;
    padding: 0px 15%;
    overflow: hidden;
    min-height: 400px;
  }

  .product-block-span {
    display: inline-block;
    width: 50%;
    text-align: left;
  }

  .product-block-span h1 {
    font-size: 32px;
    font-family: "Work Sans", sans-serif;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .product-block-span h3 {
    font-size: 18px;
    font-weight: normal;
    font-family: "Work Sans", sans-serif;
  }

  @media only screen and (max-width: 1000px) {
    .product-block-inner {
      display: block;
      min-height: 850px;
    }

    .product-block-span {
      display: block;
      width: 100%;
      text-align: center;
    }

    .product-block-span h1 {
      font-size: 24px;
    }

    .product-block-span h3 {
      max-width: 400px;
      margin: 0 auto;
      margin-bottom: 32px;
    }
  }

  .social-logo {
    background: white;
    height: 36px;
    width: 36px;
    display: inline-block;
    border-radius: 100px;
    padding: 8px;
    border: 4px solid #f3f3f3;
  }

  .social-logo img {
    display: block;
    width: 36px;
  }

  .odd-class {
    margin-bottom: -24px;
    margin-right: -24px;
    margin-left: -24px;
  }

  .even-class {

  }

  @media only screen and (max-width: 800px) {
    .product-block-inner {
      padding: 12px;
      min-height: 300px;
      margin-top: 0px;
    }

    .hero-social-logos {
      text-align: center;
      margin-bottom: 48px;
    }
  }

  /* Component Specific */

  .step-four-top-margin {
    margin-top: 0px;
  }

  .optimize-image {
    width: 524px;
    margin-top: 0px;
  }

  @media only screen and (max-width: 1000px) {
    .step-four-top-margin {
      margin-top: 0px;
    }
    .optimize-image {
      width: 90%;
      margin: 0 auto;
      margin-top: 32px;
    }
  }


</style>



// WEBPACK FOOTER //
// StepOwnYourAudience.vue?34fcb45a